import axios, { AxiosError } from "axios";

export default function errorResolver({
  error,
  setNotification,
}: {
  error: any;
  setNotification: (payload: {
    type: "error" | "success" | "warning";
    message: string;
  }) => void;
}) {
  if (axios.isCancel(error)) {
    setNotification({ type: "error", message: "ریکوئست لغو شد." });
  } else if (error.response) {
    // Server responded with a status code outside the 2xx range
    setNotification({
      type: "error",
      message: error.response.data.message || "خطا در  سرور رخ داده است.",
    });
    if (error.response.status == "401") {
      return "unauthorized";
    }
  } else if (error.request) {
    // Request was made, but no response was received
    setNotification({
      type: "error",
      message: "پاسخی از سرور دریافت نشد. لطفا اتصال اینترنت را بررسی کنید.",
    });
    if (error.request.status == "401") {
      return "unauthorized";
    }
  } else if (error.code === "ECONNABORTED") {
    // Request timeout
    setNotification({
      type: "error",
      message: "پاسخی از سرور دریافت نشد (time out). لطفا دوباره تلاش کنید.",
    });
  } else {
    // Something else happened
    setNotification({
      type: "error",
      message: error.message || "خطای ناشناخته",
    });
  }
  console.error(error);
  return null;
}
